import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const Processing = () => {
  return <ObsIframe path="/tasklist/processing-task" />;
};

export default React.memo(Processing);
